import React from 'react'
import { isBaileyProvider, isMetaProvider, isWhatsappActivated } from '../../../../../contexts/AuthProvider/AuthProvider.helpers';
import {
    WhatsApp as WhatsAppIcon,
    SettingsOutlined,
} from "@mui/icons-material";
import { useAuth } from '../../../../../contexts/AuthProvider';
import { Box, Button, Stack, Typography } from '@mui/material';
import { WhatsappQrNotActive } from './WhatsappQrNotActive';
import { useNavigate } from 'react-router-dom';
interface IWhatsappActivationGuardProps {
    children: React.ReactNode;
}
export const WhatsappActivationGuard: React.FC<IWhatsappActivationGuardProps> = ({ children }) => {
    const { whatsappService } = useAuth();
    const navigate = useNavigate()
    if (isMetaProvider(whatsappService) && !isWhatsappActivated(whatsappService)) {
        return (
            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#f0f2f5",
                    height: "100%",
                    borderBottom: "6px solid #43c4a0",
                }}
            >
                <Box
                    sx={{
                        width: 80,
                        height: 80,
                        borderRadius: "50%",
                        bgcolor: "warning.light",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <SettingsOutlined sx={{ fontSize: 40, color: "warning.dark" }} />
                </Box>
                <Typography variant="h5" fontWeight={600} textAlign="center">
                    WhatsApp Service Not Configured
                </Typography>
                <Typography variant="body1" color="text.secondary" textAlign="center" maxWidth={400}>
                    Please configure your WhatsApp Meta service first to start sending and receiving messages.
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate("/org-env-config")}
                    sx={{ mt: 2 }}
                >
                    Go to Configuration
                </Button>

            </Box>
        )
    }

    if (isBaileyProvider(whatsappService) && !isWhatsappActivated(whatsappService)) {
        return <WhatsappQrNotActive />
    }

    return <>{children}</>
}
